// Terms.js
import React from 'react';
import '../css/Privacy.css';

const Terms = () => {
  return (
    <div className="privacy-container">
        <h1>Terms of Service</h1>
        <p className="last-updated"><strong>Last Updated:</strong> February 25, 2026</p>

        <section>
          <h2>What You're Agreeing To</h2>
          <p>
            By using LinknTrack, whether through the website, Chrome extension, or API, you agree to these terms. If you don't agree, don't use the service.
          </p>
        </section>

        <section>
          <h2>What LinknTrack Is</h2>
          <p>
            LinknTrack is a Chrome Extension and web service that lets you save personal notes on LinkedIn profiles. You can set reminders, tag notes, and manage them from a dashboard on our website.
          </p>
        </section>

        <section>
          <h2>Your Account</h2>
          <ul>
            <li>You need an account to use LinknTrack. You can sign up with email or Google.</li>
            <li>You're responsible for keeping your login credentials safe.</li>
            <li>One account per person. Don't share accounts.</li>
            <li>You must be at least 13 years old to use LinknTrack.</li>
            <li>The information you provide during registration must be accurate.</li>
          </ul>
        </section>

        <section>
          <h2>Your Notes and Content</h2>
          <p>
            The notes you create are yours. We don't claim ownership of your content. However, by using the service, you give us permission to store, encrypt, and transmit your notes as needed to make the service work.
          </p>
          <p>
            You're responsible for what you write in your notes. Don't use LinknTrack to store illegal content, harass others, or violate anyone's rights.
          </p>
        </section>

        <section>
          <h2>What You Can't Do</h2>
          <ul>
            <li>Reverse engineer, decompile, or try to extract the source code of LinknTrack.</li>
            <li>Use automated tools (bots, scrapers) to access our service.</li>
            <li>Attempt to bypass rate limits, authentication, or security measures.</li>
            <li>Use LinknTrack to spam, phish, or do anything illegal.</li>
            <li>Resell or redistribute access to LinknTrack.</li>
            <li>Interfere with the service or other users' ability to use it.</li>
          </ul>
        </section>

        <section>
          <h2>The Gmail API</h2>
          <p>
            LinknTrack uses the Gmail API to send you emails: note reminders, verification codes, and password resets. That's the only thing we do with it. Our use of the Gmail API follows <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noopener noreferrer">Google API Services User Data Policy</a>, including the Limited Use requirements.
          </p>
        </section>

        <section>
          <h2>Availability</h2>
          <p>
            We do our best to keep LinknTrack running, but we can't promise 100% uptime. The service might go down for maintenance, server issues, or things outside our control. We won't be liable for any downtime or data loss.
          </p>
        </section>

        <section>
          <h2>Termination</h2>
          <p>
            You can stop using LinknTrack and request account deletion at any time by emailing <strong>linkntrack@gmail.com</strong>.
          </p>
          <p>
            We can suspend or terminate your account if you violate these terms or abuse the service. We'll try to notify you first, but we're not obligated to.
          </p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>
            LinknTrack is provided "as is." We don't guarantee that it'll be error-free, uninterrupted, or that your data will never be lost. Back up anything important.
          </p>
          <p>
            To the extent allowed by law, LinknTrack and its team are not liable for any indirect, incidental, or consequential damages arising from your use of the service.
          </p>
        </section>

        <section>
          <h2>Changes to These Terms</h2>
          <p>
            We may update these terms. If we do, we'll change the "Last Updated" date at the top. Continued use of LinknTrack after changes means you accept the new terms.
          </p>
        </section>

        <section>
          <h2>Privacy</h2>
          <p>
            Your privacy matters. See our <a href="/privacy">Privacy Policy</a> for the full details on what we collect and how we handle it.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            Got questions about these terms? Email us at <strong>linkntrack@gmail.com</strong>.
          </p>
        </section>
    </div>
  );
};

export default Terms;
